import HttpClient from 'utils/httpclient'
import config from 'config'
import BaseStore from 'stores/BaseStore'

export default new class DatasourceStore extends BaseStore {
  constructor() {
    super('datasources', 'datasources', { site_model: true })
  }

  async test({ test: query, ...payload }) {
    const params = { siteId: this.getCurrentSiteID() }
    const { data } = await HttpClient.post(`${config.api}/${this.entityName}/test`, { payload, query }, { params })
    return data
  }
}